<template>
    <div>
        <div class="navbar justify-content-between">
            <div class=" ">
                <button type="button" id="hamburger" class=" dismiss hamburger is-closed animated fadeInLeft" data-toggle="offcanvas" @click="hamburger_cross()">
                    <span class="hamb-top"></span>
                    <span class="hamb-middle"></span>
                    <span class="hamb-bottom"></span>
                </button>
                
                <nav id="sidebar" class="" :style="sidehide">
                    <ul class="list-unstyled components" id="sidebarUl">
                        <li v-if="CustomerCode == 1099 || CustomerCode == 1110">
                            <a class="nav-link" ><router-link :to="`/index`" class="routerHome">{{ $t('sidebar.home') }}</router-link></a> 
                        </li>
                        <!--影片課程-->
                        <li v-if="CustomerCode == 1160">
                            <a class="nav-link" ><router-link :to="`/Video`" class="routerHome">影片課程</router-link></a>
                        </li>
                        <li v-if="CustomerCode == 1160">
                            <a class="nav-link routerHome"  @click="openHiQuiz()">HiQuiz</a>
                            <!--<a class="nav-link routerHome"  @click="openHiQuiz()"v-if="">HiQuiz</a>-->
                        </li>
                        <li v-if="CustomerCode == 1110 || CustomerCode == 1160">
                            <a class="nav-link" ><router-link :to="`/deviceTest`" class="routerHome">{{ $t('sidebar.deviceTest') }}</router-link></a>
                        </li>
                        <li v-if="CustomerCode == 1099">
                            <a class="nav-link" @click="openDeviceTestFor2B()">{{ $t('sidebar.deviceTest') }}</a>
                        </li>
                        <li v-if="CustomerCode == 1099 || CustomerCode == 1110">
                            <a class="nav-link routerHome"  @click="openLearningProfile()">{{ $t('sidebar.learningProfile') }}</a>
                        </li>
                        <li v-if="CustomerCode == 1099 || CustomerCode == 1110">
                            <a class="nav-link" ><router-link :to="`/AttendanceRecord`" class="routerHome">{{ $t('sidebar.attendanceRecord') }}</router-link></a>
                        </li>
                        <li v-if="CustomerCode == 1099 || CustomerCode == 1110">
                            <a class="nav-link" ><router-link :to="`/PersonalInfo`" class="routerHome">{{ $t('sidebar.personalInfo') }}</router-link></a>
                        </li>
                        <li>
                            <a class="nav-link routerHome" @click="openEVLevelExplanation()">{{ $t('sidebar.EVLevelExplanation') }}</a>
                        </li>
                        <li>
                            <a class="nav-link" @click="close()">{{ $t('sidebar.logout') }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="overlay"></div>
            
            </div>
            <div class="d-flex ">
                <span style="align-self: center;">{{EnglishName}}({{StudentUserId}})</span>
                <span class="pl-2">{{UTC}}</span>
                <!--<a class="nav-link" @click="close()">登出</a>  -->   
                <span class="pl-2">
                    <select id="currentLocale" v-model="currentLocale" @change="changeLocale">
                        <option value="en">{{ $t('langlist.English') }}</option>
                        <option value="tw">{{ $t('langlist.TraditionalChinese') }}</option>
                    </select>   
                </span>    
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'NavBar',
    data () {
        return {
            EnglishName:sessionStorage.getItem('EnglishName')==null?this.GLOBAL.EnglishName:sessionStorage.getItem('EnglishName'),
            StudentUserId:sessionStorage.getItem('StudentUserId')==null?this.GLOBAL.StudentUserId:sessionStorage.getItem('StudentUserId'),
            masterURL:'https://student-center.hi-tr.com/HiNote/LearningProfileRWD?StudentId=',
            demoURL:'https://demostudentcenter.hitutoracdm.com/HiNote/LearningProfileRWD?StudentId=',
            HiQuizDemoUrl:'http://hiquizdemo.hitutor.com.tw/',
            HiQuizMasterUrl:'http://hiquiz.hi-tr.com/',
            SideBarClosed:false,
            sidehide:"left : 0",
            UTC:'',
            CustomerCode:sessionStorage.getItem('CustomerCode'),
            DeviceTestFor2B:`${process.env.TEACHINGPLATFORM}NewTeachingPlatform/deviceTest?UserId=`+ btoa(sessionStorage.getItem('StudentUserId')),
            currentLocale: this.$i18n.locale
        }
    },
    created(){
        var nowDate = new Date();
        // console.log(nowDate);
        var a= nowDate.toString().indexOf('GMT');
        var b = nowDate.toString().substring(a+3,a+4);
        var c = parseFloat(nowDate.toString().substring(a+4,a+6));
        this.UTC = '(UTC' + b + c + ')';

        var lang = localStorage.getItem('lang');
        if(lang != null)
        {
            this.changeLang(lang)
        }
    },
    methods:{
        close(){
            if(this.CustomerCode == '1160'){
                sessionStorage.removeItem('Token')
                sessionStorage.removeItem('StudentUserId')
                sessionStorage.removeItem('StudentId')
                sessionStorage.removeItem('CustomerCode')
                window.location.href=`${process.env.LOGOUTPATH}`;
            }else{
                window.location.href="about:blank";
                window.close();
            }
        },
        openLearningProfile(){
            // console.log(`${process.env.ISMASTER}`)
            // console.log(`${process.env.NODE_ENV}`)
            var url = '';
            if(`${process.env.NODE_ENV}` == "production"){//master
            // if(`${process.env.ISMASTER}` == true){//master
                url = this.masterURL+sessionStorage.getItem('StudentId');
            }else{//demo
                url = this.demoURL+sessionStorage.getItem('StudentId');
            }
            // var url = 'https://demostudentcenter.hitutoracdm.com/HiNote/LearningProfileRWD?StudentId='+sessionStorage.getItem('StudentId');
            window.open(url, '_blank')
        },
        openHiQuiz(){
            var url = '';
            if(`${process.env.NODE_ENV}` == "production"){//master
                url = this.HiQuizMasterUrl + '?token=' + sessionStorage.getItem('Token') + '&userId=' + sessionStorage.getItem('StudentUserId');
            }else{ //demo
                url = this.HiQuizDemoUrl + '?token=' + sessionStorage.getItem('Token') + '&userId=' + sessionStorage.getItem('StudentUserId');
            }
            window.open(url, '_blank');
        },        
        openDeviceTestFor2B(){            
            var url = this.DeviceTestFor2B;
            window.open(url, '_blank');
        },
        openEVLevelExplanation(){
            var url = 'https://fs.hi-tr.com/i!MTUyNTMxMjA=';
            window.open(url, '_blank')
        },
        //css
        hamburger_cross(){
            var hamburger = document.getElementsByClassName('hamburger');
            var overlay =  document.getElementsByClassName('overlay');

            if (this.SideBarClosed) {     
                this.sidehide = "left:0"
                hamburger[0].classList.remove('is-open');
                hamburger[0].classList.add('is-closed');
                this.SideBarClosed = false;
            } else {   
                this.sidehide = "left:220px"
                hamburger[0].classList.remove('is-closed');
                hamburger[0].classList.add('is-open');
                this.SideBarClosed = true;
            }
        },
        changeLocale() {
            localStorage.setItem('lang',this.currentLocale)
            this.changeLang(this.currentLocale);
            location.reload();
        },
        changeLang(lang) {
            this.$i18n.locale = lang;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue